import request from '@/utils/request';
export const defaultDealersRoleData = {
  id: 0,
  enabled: true,
  name: ''
};
export const getDealersRoles = params => request({
  url: '/dealers-roles',
  method: 'get',
  params
});
export const getDealersRoleById = id => request({
  url: `/dealers-roles/${id}`,
  method: 'get'
});
export const updateDealersRole = (id, data) => request({
  url: `/dealers-roles/${id}`,
  method: 'patch',
  data
});
export const deleteDealersRole = id => request({
  url: `/dealers-roles/${id}`,
  method: 'delete'
});
export const createDealersRole = data => request({
  url: '/dealers-roles',
  method: 'post',
  data
});